if (typeof window === 'undefined') {
  require('dotenv').config();
}

const ANDROID_VERSION =
  process.env.NEXT_PUBLIC_APP_ANDROID_VERSION_NAME ??
  process.env.APP_VERSION ??
  '4.3.0';
const IOS_VERSION =
  process.env.NEXT_PUBLIC_APP_IOS_VERSION_NAME ??
  process.env.APP_VERSION ??
  '4.3.0';
const SENTRY_ANDROID_APP_ID = 'com.InforCFC';
const SENTRY_SUFIX_RELEASE = `ANDROID-${ANDROID_VERSION}-IOS-${IOS_VERSION}`;
const SENTRY_RELEASE = `${SENTRY_ANDROID_APP_ID}@${SENTRY_SUFIX_RELEASE}`;
const SENTRY_ORG = 'inforcfc-go';
const SENTRY_PROJECT = 'capacitor-app-inforcfc';
const SENTRY_SOURCE = 'app-inforcfc';
const SENTRY_DSN =
  'https://91545194d4d7601e2a6f64e19bf95506@o4509560157110274.ingest.us.sentry.io/4509560158748672';
const SENTRY_DIST = '1.0.0';

module.exports = {
  ANDROID_VERSION,
  IOS_VERSION,
  SENTRY_ANDROID_APP_ID,
  SENTRY_SUFIX_RELEASE,
  SENTRY_RELEASE,
  SENTRY_ORG,
  SENTRY_PROJECT,
  SENTRY_SOURCE,
  SENTRY_DSN,
  SENTRY_DIST,
};
